import { cn } from '../../utils/cn'
import { Skeleton } from './skeleton'
import { TableCell, TableRow } from './table'

// Cycled so the placeholder reads like real data instead of a uniform grid.
const CELL_WIDTHS = ['w-36', 'w-20', 'w-28', 'w-16', 'w-24', 'w-32', 'w-20', 'w-24']

interface TableSkeletonRowsProps {
  /** Column count — match the table header so the placeholder lines up. */
  columns: number
  rows?: number
}

/**
 * Placeholder rows for a table whose data is still loading. Render inside
 * <TableBody>. Hidden from screen readers — a table of empty cells is noise.
 */
export function TableSkeletonRows({ columns, rows = 8 }: TableSkeletonRowsProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex} aria-hidden className="hover:bg-transparent">
          {Array.from({ length: columns }).map((_, columnIndex) => (
            <TableCell key={columnIndex}>
              <Skeleton className={cn('h-4', CELL_WIDTHS[columnIndex % CELL_WIDTHS.length])} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  )
}
